/* TestimonialCard — Premium testimonial with gradient accent */

interface TestimonialCardProps {
  data: Record<string, string>
  entityData?: Record<string, unknown>
}

export default function TestimonialCard({ data, entityData }: TestimonialCardProps) {
  const quote = (entityData?.content as string) || (entityData?.quote as string) || data.quote || '"An incredible experience."'
  const author = (entityData?.author_name as string) || (entityData?.client_name as string) || data.author || 'Happy Client'
  const rating = (entityData?.rating as number) || parseInt(data.rating || '5', 10)

  return (
    <div data-testid="card-testimonial" className="group relative h-full rounded-xl overflow-hidden bg-gradient-to-br from-white/[0.04] to-white/[0.01] border border-white/[0.06] hover:border-white/[0.12] transition-[border-color,transform] duration-300 hover:-translate-y-0.5">
      {/* Left accent stripe */}
      <div className="absolute left-0 top-4 bottom-4 w-0.5 rounded-full bg-gradient-to-b from-blue-500/40 via-purple-400/30 to-transparent" />

      <div className="p-5 pl-6">
        {/* Quote icon */}
        <div className="mb-3">
          <svg className="w-5 h-5 text-blue-500/20" fill="currentColor" viewBox="0 0 24 24">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10H14.017zM0 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10H0z" />
          </svg>
        </div>

        {/* Quote text */}
        <p className="text-sm text-white/60 leading-relaxed italic mb-4 group-hover:text-white/70 transition-colors">
          {quote}
        </p>

        {/* Author row */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-full bg-gradient-to-br from-blue-500/20 to-purple-500/10 flex items-center justify-center">
              <span className="text-[9px] font-bold text-white/50">{author.charAt(0)}</span>
            </div>
            <span className="text-xs font-medium text-white/50">{author}</span>
          </div>

          {/* Stars */}
          {rating > 0 && (
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <svg
                  key={i}
                  className={`w-3 h-3 ${i < rating ? 'text-amber-400/70' : 'text-white/10'}`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
